import { c as _c } from "react/compiler-runtime";
import "client-only";
import { useComments } from "@/components/Comment/context/comments.context";
import type { CommentModel, PaginatedCommentsModel } from "@/services/api/comment/models/comment.model.types";
export function useCommentsActions() {
  const $ = _c(2);
  const {
    dispatch
  } = useComments();
  let t0;
  if ($[0] !== dispatch) {
    t0 = {
      addComment: comment => dispatch({
        comment,
        type: "ADD_COMMENT"
      }),
      addReply: (reply, ancestorId) => dispatch({
        ancestorId,
        reply,
        type: "ADD_REPLY"
      }),
      appendComments: paginated => dispatch({
        paginated,
        type: "APPEND_COMMENTS"
      }),
      appendReplies: (commentId, paginated_0) => dispatch({
        commentId,
        paginated: paginated_0,
        type: "APPEND_REPLIES"
      }),
      closeModal: () => dispatch({
        type: "CLOSE_MODAL"
      }),
      openModal: () => dispatch({
        type: "OPEN_MODAL"
      })
    };
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}